@if (isFinancingEnabled && data && data.is_financing_eligible && configuration.iframeUrl &&
configuration.iframeHeight) {
<div class="iframe-container">
    <iframe
        [src]="getSanitizedUrl(configuration.iframeUrl)"
        [height]="configuration.iframeHeight"
        width="100%"
    ></iframe>
</div>
}
